module.exports = __webpack_public_path__ + "img/platinum@2x.3c07249.webp";